export default __webpack_public_path__ + "static/Plots0003-0ddb189d42384be8fce33b12ee613155.jpg";